import { createPopper } from '@popperjs/core'

export const createTooltipText = (textHtml: string, element: HTMLElement, className: string = '') => {
  const tooltipHtml = document.createElement('span')
  tooltipHtml.className = className

  // Mathlive のため以下の修正が無効にします。
  // tooltipHtml.innerHTML = String(text)
  //   .replace(/&/g, '&amp;')
  //   .replace(/</g, '&lt;')
  //   .replace(/>/g, '&gt;')
  //   .replace(/"/g, '&quot;')
  // ;
  tooltipHtml.innerHTML = textHtml;
  (element.parentElement as any).append(tooltipHtml)
  // element.style.width = `${text.length * 10}px`
  // Pass the button, the tooltip, and some options, and Popper will do the
  // magic positioning for you:
  createPopper(element, tooltipHtml as HTMLElement, {
    placement: 'bottom'
  })
}
